/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { IconButton } from "@mui/material";
import { IconClearFormatting } from "@tabler/icons-react";
import { useCurrentEditor } from "@tiptap/react";
import { useTranslation } from "react-i18next";
import { ButtonTooltip } from "./toolbar-button/button-tooltip";

const ClearFormattingButton = () => {
    const { editor } = useCurrentEditor();
    const { t } = useTranslation();

    function clear () {
        editor.chain().focus().clearNodes().unsetAllMarks().run();
    }

    return (
        <ButtonTooltip title={t("Editor.clearFormat")}>
            <IconButton onClick={clear}>
                <IconClearFormatting />
            </IconButton>
        </ButtonTooltip>
    );
};

export { ClearFormattingButton };
